import React, { useEffect, useState } from 'react';
import { diagnosisProcessText } from 'constants/diagnosisListPageConstants';
import styled from 'styled-components';
import { font, palette } from 'styles/Global/globalStyles';
import { ProcessCheckBarContainerProps, ProgressCheckBarProps } from 'models/Common/buttonTypes';
import { Accent, BackgroundColor, IconColor, InverseColor, PrimaryColor, TextColor } from 'styles/Global/colorSemantic';
import { useLocation } from 'react-router-dom';
import ProcessToolTip from 'components/ToolTip/ProcessToolTip';
import ArrowRightSlim from 'assets/Icons/Arrow/ArrowRightSlim';
import { AssessmentStatus } from 'utils/statusCode';
import NoShowToolTip from 'components/ToolTip/NoShowToolTip';
import { getDiagnosisStatus } from 'pages/DCK/utils';
import Check from 'assets/Icons/Check/Check';
import IcArrowRightSlim from 'assets/Icons/Arrow/IcArrowRightSlim';

const ProcessCheckBar = ({ diagnosisInfo, $height, $width, onClick, $type, $top, $left, hover, $barType, onCLickInMindUpMobileAdmin }: ProgressCheckBarProps) => {
    const [processingCount, setprocessingCount] = useState(0);
    const [completeDiagnosis, setCompleteDiagnosis] = useState(0);
    const [ProcessBarHover, setProcessBarHover] = useState(false);
    // const [ProcessBarStatus, setProcessBarStatus] = useState<ProcessCheckBarContainerProps['$ProcessBarStatus']>('');

    const { pathname } = useLocation();

    useEffect(() => {
        let processingCount = 0;
        let completeDiagnosisCount = 0;

        if (diagnosisInfo) {
            diagnosisInfo.assessmentList?.filter((assessment) => (assessment.status === AssessmentStatus.inProgress || assessment.status === AssessmentStatus.completed) && processingCount++);
            diagnosisInfo.assessmentList?.filter((assessment) => assessment.status === AssessmentStatus.completed && completeDiagnosisCount++);
        }

        setprocessingCount(processingCount);
        setCompleteDiagnosis(completeDiagnosisCount);
    }, [diagnosisInfo]);

    return (
        <Container
            $type={$barType}
            $height={$height}
            $width={$width}
            onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                event.stopPropagation();
                if (getDiagnosisStatus(diagnosisInfo!) !== 'noshow') {
                    onCLickInMindUpMobileAdmin && onCLickInMindUpMobileAdmin(diagnosisInfo!);
                    onClick && onClick();
                }
            }}
            $ProcessBarStatus={getDiagnosisStatus(diagnosisInfo!)}
            onMouseEnter={() => !hover && setProcessBarHover(true)}
            onMouseLeave={() => !hover && setProcessBarHover(false)}
        >
            {ProcessBarHover && getDiagnosisStatus(diagnosisInfo!) === 'noshow' && $type !== 'todayDiagnosisList' && diagnosisInfo?.noShowInfo?.length !== 0 && (
                <NoShowToolTip diagnosisInfo={diagnosisInfo!} $top={$top} $left={$left} />
            )}
            {ProcessBarHover &&
                getDiagnosisStatus(diagnosisInfo!) !== 'notAssigned' &&
                getDiagnosisStatus(diagnosisInfo!) !== 'noshow' &&
                getDiagnosisStatus(diagnosisInfo!) !== 'reschedule' &&
                $type !== 'todayDiagnosisList' && <ProcessToolTip diagnosisInfo={diagnosisInfo} />}
            <InnerLeftWrapper $ProcessBarStatus={getDiagnosisStatus(diagnosisInfo!)}>
                <CircleAndTextWrapper $type={$type}>
                    {getDiagnosisStatus(diagnosisInfo!) !== 'counselReserved' && getDiagnosisStatus(diagnosisInfo!) !== 'reschedule' && (
                        <Circle $ProcessBarStatus={getDiagnosisStatus(diagnosisInfo!)} $type={$type} />
                    )}
                    {getDiagnosisStatus(diagnosisInfo!) === 'notAssigned'
                        ? diagnosisProcessText.NOT_ASSIGNED
                        : getDiagnosisStatus(diagnosisInfo!) === 'pending'
                        ? diagnosisProcessText.PENDING
                        : getDiagnosisStatus(diagnosisInfo!) === 'inProgress'
                        ? diagnosisProcessText.INPROGRESS
                        : getDiagnosisStatus(diagnosisInfo!) === 'completed'
                        ? diagnosisProcessText.COMPLETED
                        : getDiagnosisStatus(diagnosisInfo!) === 'noshow'
                        ? diagnosisProcessText.NO_SHOW
                        : getDiagnosisStatus(diagnosisInfo!) === 'reschedule'
                        ? diagnosisProcessText.RESCHEDULE
                        : getDiagnosisStatus(diagnosisInfo!) === 'counselReserved'
                        ? diagnosisProcessText.COUNSEL_ASSIGNED
                        : diagnosisProcessText.COUNSEL_COMPLETED}
                </CircleAndTextWrapper>
                {/* //! height check */}
                {getDiagnosisStatus(diagnosisInfo!) === 'notAssigned' && pathname !== '/counseling/detail-diagnosis' && $type !== 'todayDiagnosisList' && <ArrowRightSlim />}
                {getDiagnosisStatus(diagnosisInfo!) === 'notAssigned' && pathname !== '/counseling/detail-diagnosis' && $type === 'todayDiagnosisList' && <ArrowRightSlim />}
            </InnerLeftWrapper>
            {getDiagnosisStatus(diagnosisInfo!) !== 'counselReserved' && diagnosisInfo && (
                <InnerCountWrapper>
                    {getDiagnosisStatus(diagnosisInfo!) === 'pending' && (
                        <>
                            <Count $type={$type}>0/</Count>
                            <BlackCount $type={$type}>{diagnosisInfo.assessmentList?.length}</BlackCount>
                        </>
                    )}
                    {getDiagnosisStatus(diagnosisInfo!) === 'inProgress' && (
                        <>
                            <BlackCount $type={$type}>{processingCount}</BlackCount>
                            <Count $type={$type}>/{diagnosisInfo.assessmentList?.length}</Count>
                        </>
                    )}
                    {getDiagnosisStatus(diagnosisInfo!) === 'completed' && <BlackCount $type={$type}>{completeDiagnosis}</BlackCount>}
                    {getDiagnosisStatus(diagnosisInfo!) === 'counselComplete' && (
                        <Check $width={$type === 'mindupAdminMobile' ? '16' : '20'} $height={$type === 'mindupAdminMobile' ? '16' : '20'} $position='static' $color={IconColor.color_icon_heavy} />
                    )}
                </InnerCountWrapper>
            )}
        </Container>
    );
};

export default ProcessCheckBar;

const CircleAndTextWrapper = styled.div<{ $type?: string }>`
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: ${(props) => (props.$type === 'todayDiagnosisList' || props.$type === 'mindupAdminMobile') && font.size[13]};
`;

const Container = styled.button<ProcessCheckBarContainerProps>`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-radius: ${(props) => (props.$type === 'mobile' ? '8px' : '99px')};
    width: ${(props) => props.$width || '100%'};
    height: ${(props) => props.$height || '100%'};
    color: ${(props) =>
        props.$ProcessBarStatus === 'counselReserved' || props.$ProcessBarStatus === 'reschedule'
            ? InverseColor.color_inverse_white
            : props.$ProcessBarStatus === 'noshow'
            ? TextColor.color_text_light
            : TextColor.color_text_normal};
    // cursor: ${(props) => props.$ProcessBarStatus === 'noshow' && 'default'};
    background-color: ${(props) =>
        props.$ProcessBarStatus === 'notAssigned'
            ? Accent.color_accent_yellow_weak
            : props.$ProcessBarStatus === 'pending'
            ? Accent.color_accent_lime_weak
            : props.$ProcessBarStatus === 'inProgress'
            ? Accent.color_accent_cyan_weak
            : props.$ProcessBarStatus === 'completed'
            ? BackgroundColor.color_background_primary_strong
            : props.$ProcessBarStatus === 'noshow'
            ? BackgroundColor.color_background_normal
            : props.$ProcessBarStatus === 'reschedule'
            ? BackgroundColor.color_background_darkgray_normal
            : props.$ProcessBarStatus === 'counselReserved'
            ? PrimaryColor.color_primary_normal
            : props.$ProcessBarStatus === 'counselComplete'
            ? Accent['color_accent-purple-opacity-8']
            : BackgroundColor.color_background_primary_normal};

    border: 1px solid
        ${(props) =>
            props.$ProcessBarStatus === 'notAssigned'
                ? Accent['color-accent-yellow-opacity-8']
                : props.$ProcessBarStatus === 'pending'
                ? Accent['color-accent-lime-opacity-8']
                : props.$ProcessBarStatus === 'inProgress'
                ? Accent['color-accent-cyan-opacity-8']
                : PrimaryColor['color_primary_light-8']};
    &:hover {
        background-color: ${(props) =>
            props.$ProcessBarStatus === 'notAssigned'
                ? Accent.color_accent_yellow_light
                : props.$ProcessBarStatus === 'pending'
                ? Accent.color_accent_lime_light
                : props.$ProcessBarStatus === 'inProgress'
                ? Accent.color_accent_cyan_light
                : props.$ProcessBarStatus === 'completed'
                ? BackgroundColor.color_background_primary_over
                : props.$ProcessBarStatus === 'noshow'
                ? 'none'
                : // ? BackgroundColor.color_background_strong
                props.$ProcessBarStatus === 'reschedule'
                ? BackgroundColor.color_background_darkgray_strong
                : props.$ProcessBarStatus === 'counselReserved'
                ? PrimaryColor.color_primary_strong
                : Accent['color_accent-purple-opacity-8']};
    }
    &:active {
        background-color: ${(props) =>
            props.$ProcessBarStatus === 'notAssigned'
                ? Accent.color_accent_yellow_light
                : props.$ProcessBarStatus === 'pending'
                ? Accent.color_accent_lime_light
                : props.$ProcessBarStatus === 'inProgress'
                ? Accent.color_accent_cyan_light
                : props.$ProcessBarStatus === 'completed'
                ? BackgroundColor.color_background_primary_over
                : props.$ProcessBarStatus === 'noshow'
                ? 'none'
                : // ? BackgroundColor.color_background_heavy
                props.$ProcessBarStatus === 'reschedule'
                ? BackgroundColor.color_background_darkgray_heavy
                : props.$ProcessBarStatus === 'counselReserved'
                ? PrimaryColor.color_primary_heavy
                : Accent['color_accent-purple-opacity-8']};
    }
    &:focus {
        background-color: ${(props) =>
            props.$ProcessBarStatus === 'notAssigned'
                ? Accent.color_accent_yellow_light
                : props.$ProcessBarStatus === 'pending'
                ? Accent.color_accent_lime_light
                : props.$ProcessBarStatus === 'inProgress'
                ? Accent.color_accent_cyan_light
                : props.$ProcessBarStatus === 'completed'
                ? BackgroundColor.color_background_primary_over
                : props.$ProcessBarStatus === 'noshow'
                ? 'none'
                : // ? BackgroundColor.color_background_heavy
                props.$ProcessBarStatus === 'reschedule'
                ? BackgroundColor.color_background_darkgray_heavy
                : props.$ProcessBarStatus === 'counselReserved'
                ? PrimaryColor.color_primary_heavy
                : Accent['color_accent-purple-opacity-8']};
    }
    &:disabled {
        background-color: ${(props) =>
            props.$ProcessBarStatus === 'notAssigned'
                ? Accent.color_accent_yellow_weak
                : props.$ProcessBarStatus === 'pending'
                ? Accent.color_accent_lime_weak
                : props.$ProcessBarStatus === 'inProgress'
                ? Accent.color_accent_cyan_weak
                : props.$ProcessBarStatus === 'noshow'
                ? BackgroundColor.color_background_normal
                : BackgroundColor.color_background_primary_heavy};
    }
`;

const InnerLeftWrapper = styled.div<ProcessCheckBarContainerProps>`
    display: flex;
    align-items: center;
    justify-content: ${(props) => (props.$ProcessBarStatus === 'counselReserved' || props.$ProcessBarStatus === 'reschedule' ? 'center' : 'space-between')};
    width: 100%;
    height: 100%;
    font-size: ${font.size[15]};
    font-weight: ${font.weight.medium};
`;

const InnerCountWrapper = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    font-size: ${font.size[15]};
    font-weight: ${font.weight.medium};
`;

const Count = styled.span<{ $type?: string }>`
    color: ${palette.gray};
    font-size: ${(props) => props.$type === 'todayDiagnosisList' && font.size[13]};
`;

const BlackCount = styled.span<{ $type?: string }>`
    font-size: ${(props) => props.$type === 'todayDiagnosisList' && font.size[13]};
`;

const Circle = styled.div<ProcessCheckBarContainerProps>`
    width: ${({ $type }) => ($type === 'mindupAdminMobile' ? '6px' : '8px')};
    height: ${({ $type }) => ($type === 'mindupAdminMobile' ? '6px' : '8px')};
    border-radius: 99px;
    background-color: ${(props) =>
        props.$ProcessBarStatus === 'notAssigned'
            ? Accent.color_accent_yellow
            : props.$ProcessBarStatus === 'pending'
            ? Accent.color_accent_lime
            : props.$ProcessBarStatus === 'inProgress'
            ? Accent.color_accent_cyan
            : props.$ProcessBarStatus === 'counselComplete'
            ? Accent.color_accent_purple_heavy
            : props.$ProcessBarStatus === 'noshow'
            ? IconColor.color_icon_normal
            : props.$ProcessBarStatus === 'counselReserved'
            ? IconColor.color_icon_normal
            : PrimaryColor.color_primary_normal};
`;
